// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const FileUploadRequestProperty = {
    file: (value) => {
        return {
            value: value,
            type: "file",
            _visit: function (visitor) {
                return FernIr.FileUploadRequestProperty._visit(this, visitor);
            },
        };
    },
    bodyProperty: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bodyProperty", _visit: function (visitor) {
                return FernIr.FileUploadRequestProperty._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "file":
                return visitor.file(value.value);
            case "bodyProperty":
                return visitor.bodyProperty(value);
            default:
                return visitor._other(value);
        }
    },
};
